import Cart from './Cart';

export default Cart;
